module.exports = __webpack_public_path__ + "static/ocean-beach.d1eb08d0.jpg";